import {
  debounce,
  t,
} from '@nova/utils'

class NovaCollectionPagination extends HTMLElement {
  constructor() {
    super()
    this.debouncedOnLoadMore = debounce(this.onLoadMoreHandler.bind(this), 500)
    this.position = this.dataset.position
    this.url = this.dataset.url
  }

  connectedCallback() {
    this.$loadMoreBtn = this.querySelector('.js-load-more')
    if (this.$loadMoreBtn) {
      this.$loadMoreBtn.addEventListener('click', this.debouncedOnLoadMore)
    }

    if (this.position === 'previous') {
      this.debouncedOnLoadMore()
    }
    this.updateViewProductsCount()
    this.restoreScrollItem()
  }

  onLoadMoreHandler(event) {
    let url = this.url
    if (event) {
      event.preventDefault()
      url = event.target.dataset.href
    }
    const sections = this.getSections()
      .map((section) => `sections[]=${section.section}`)
      .join('&')

    fetch(`${url}&${sections}`)
      .then((response) => response.json())
      .then((parsed) => {
        const html = Object.values(parsed).join('')
        this.renderProductGrid(html)
        if (this.position === 'next') {
          this.updateURLHash(url)
        }
      })
  }

  renderProductGrid(html) {
    const domHtml = new DOMParser()
      .parseFromString(html, 'text/html')
    const newProductGrid = domHtml.querySelector('.js-product-grid-list')
    const newPreviousLoadContainer = domHtml.querySelector('.js-load-previous-container')
    const newLoadMore = domHtml.querySelector('.js-load-more')
    const productGrid = document.querySelector('.js-product-grid-list')
    const previousLoadContainer = document.querySelector('.js-load-previous-container')

    let productItems = [...newProductGrid.querySelectorAll(':scope > li')]
    if (this.position === 'previous') {
      productItems = productItems.reverse()
    }
    productItems.forEach(productItem => {
      if (this.position === 'previous') {
        productGrid.insertBefore(productItem, productGrid.firstChild)
      } else {
        productGrid.appendChild(productItem)
      }
    })

    window.NovaProductCardV2?.initWithin(productGrid)

    this.updateViewProductsCount()

    if (this.$loadMoreBtn) {
      if (!newLoadMore) {
        this.$loadMoreBtn?.classList.add('hidden')
      } else {
        this.$loadMoreBtn.setAttribute('data-href', newLoadMore.dataset.href)
      }
    }

    if (this.position === 'previous') {
      previousLoadContainer.innerHTML = newPreviousLoadContainer.innerHTML
    }

    this.restoreScrollItem()
  }

  updateURLHash(url) {
    let params = new URLSearchParams(url.split('?')[1])
    params.delete('phcursor')
    params = params.toString()
    history.replaceState(
      {params},
      '',
      `?${params}`,
    )
  }

  restoreScrollItem() {
    const anchorId = location.hash
    if (!anchorId) return

    const productCardEl = document.querySelector(`[id="${anchorId.replace('#', '')}"]`)
    if (!productCardEl) return

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual'

      document.addEventListener('beforeunload', () => {
        history.scrollRestoration = 'auto'
      })
    }

    setTimeout(() => {
      productCardEl.scrollIntoView({
        behavior: 'smooth',
      })
    }, 250)
  }

  updateViewProductsCount() {
    const productGrid = document.getElementById('main-collection-product-grid')
    const productCards = productGrid.querySelectorAll('.js-product-card-v2')
    this.$viewProductsCountMarkers = document.querySelectorAll(
      '[data-view-products-count]',
    )

    this.$viewProductsCountMarkers.forEach(item => item.innerHTML = productCards.length)
  }

  getSections() {
    return [
      {
        id: 'main-collection-product-grid',
        section: document.getElementById('main-collection-product-grid').dataset
          .id,
      },
    ]
  }
}

customElements.define('nova-collection-pagination', NovaCollectionPagination)
